import { useEffect, useRef, useState } from "react"
import { SendTermsOfUseScreen } from "../../screen/SendTermsOfUseScreen"
import { customToast } from "../../components/Toast"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import { templateTermsList } from "../../core/mocks/terms"
import Send from "../../core/communication"
import { useFormProject } from "../../core/utils/hooks/useFormProject"

const customMessage = {
  templateId: "HX84ff16014247594cb094202cc54dc45a",
  title: "*Mensagem personalizada*:",
  message: ``,
}

const assistenciaTemplate = (text) => `*Assistência*:
 
    ${text}
     
    👩‍🌾`

export const SendTermsOfUseContainer = ({
  selectedUsers,
  modalTermsIsOpen,
  setModalTermsIsOpen,
  isChatContainer,
  pinnedMessages = [],
}) => {
  const { scope } = useScope()
  const {
    forms: formsByProject,
    steps,
    groups,
    groupQuestions,
    groupQuestionsWithConditional,
    setSelectedFormId,
    selectedFormId,
    setSelectedStepId,
    selectedStepId,
    setSelectedGroupId,
    selectedGroupId,
  } = useFormProject(isChatContainer && Array.isArray(selectedUsers) && selectedUsers[0]?.projectId)
  const userCreated = useUser()
  const [projectList, setProjectList] = useState([])
  const [loading, setLoading] = useState(false)
  const [values, setValues] = useState({})
  const [message, setMessage] = useState(null)
  const [showTemplateList, setShowTemplateList] = useState(false)
  const [selectedTerm, setSelectedTerm] = useState(null)
  const [checkedUsers, setCheckedUsers] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState(null)

  useEffect(() => {
    if (modalTermsIsOpen) {
      setCheckedUsers(
        Array.isArray(selectedUsers)
          ? selectedUsers.map((item) => ({
            id: item?.farmerId || item?.id,
            name: item?.farmerName || item?.name,
            projectId: item?.projectId,
            project: item?.project,
          }))
          : [],
      )

      setProjectList([...new Set(selectedUsers.map((row) => row?.projectId))])
    }
  }, [modalTermsIsOpen])

  useEffect(() => {
    if (templateTermsList(scope?.id) && templateTermsList(scope?.id).length) {
      setSelectedTerm(templateTermsList(scope?.id)[0])
    }
  }, [])

  console.log("VA", values)

  const handleCloseModal = () => setModalTermsIsOpen(false)

  const handleSelectedTerm = (termId) => {
    setSelectedTerm(templateTermsList(scope?.id).find((term) => term.id === termId))
  }

  const formatUsers = (users, noChecked = false) => {
    return users
      .map((item) => {
        const filterUser = checkedUsers.find(
          (row) => row.id === item.farmerId || row.id === item.id,
        )
        if (noChecked && filterUser) return item
        else if (!noChecked) return { ...item, isChecked: filterUser }
      })
      .filter((user) => user)
  }

  const onCheckedChange = (check, value) => {
    if (Array.isArray(check)) {
      setCheckedUsers(value === "true" ? check : [])
    } else {
      value === "true"
        ? setCheckedUsers([...checkedUsers, check])
        : setCheckedUsers(checkedUsers.filter((item) => item.id != check.id))
    }
  }

  const handleChangeInput = (field) => {
    return (value) => {
      if (field === "form") {
        if (!value) {
          setSelectedStepId(null)
        }
        setSelectedFormId(value?.value || null)
        setValues((values) => ({
          ...values,
          [field]: value,
          step: null,
          group: null,
          question: null,
        }))
        return
      }

      if (field === "step") {
        setSelectedStepId(value || null)
      }

      if (field === "group") {
        setSelectedGroupId(value || null)
      }

      setValues((values) => ({
        ...values,
        [field]: value,
      }))
    }
  }

  const handleOpenTemplateList = () => {
    setShowTemplateList(true)
  }

  const handleCloseTemplateList = () => {
    setSelectedTemplate(null)
    setShowTemplateList(false)
  }

  const handleSetSelectedTemplate = (value) => {
    setSelectedTemplate(value)
    setMessage(null)
  }

  const sendDataToGenerateLink = async () => {
    if (!values || !values.form) {
      throw new Error("Preencha todos os campos!")
    }

    if (!message && !selectedTemplate?.message) {
      throw new Error("Preencha a mensagem que deseja enviar")
    }

    try {
      // const result = await swal({
      //   title: 'Digite qual mensagem deseja enviar',
      //   content: {
      //     element: 'textarea',
      //     attributes: {
      //       id: 'textarea-input',
      //       className: 'swal-content__textarea',
      //       style: 'width: 100%; height: 150px;',
      //       placeholder: 'Digite a mensagem (ex: Meu link é {{1}}. Deve incluir {{1}})',
      //     },
      //   },
      //   buttons: {
      //     cancel: 'Ignorar',
      //     confirm: {
      //       text: 'Confirmar',
      //     },
      //   },
      // });

      // if (result === null) {
      //   console.log('Operação ignorada pelo usuário.');
      //   return;
      // }

      let messageTxt = message || selectedTemplate?.message // document.getElementById('textarea-input').value.trim();
      const extraData = {}

      if (!messageTxt.includes("{{1}}") && showTemplateList) {
        messageTxt = messageTxt.concat("\n{{1}}")
      }

      if (selectedTemplate?.templateId) {
        extraData["templateId"] = selectedTemplate?.templateId
      }

      const template = {
        ...extraData,
        // ...customMessage,
        message: showTemplateList ? messageTxt : assistenciaTemplate(messageTxt),
      }

      await sendData(template)

      // const firstSwal = await swal({
      //   title: 'Deseja enviar com "Assistência:"?',
      //   text: "Deseja prosseguir?",
      //   icon: "warning",
      //   className: "swal-send-assistance",
      //   closeOnClickOutside: false,
      //   buttons: {
      //     cancel: "Cancelar",
      //     roll: {
      //       text: 'Sim, enviar como "Assistência"',
      //       value: "assistance",
      //     },
      //     confirm: {
      //       text: "Continuar com texto original",
      //       value: "original",
      //     },
      //   },
      // })

      // if (firstSwal) {
      //   if (firstSwal === "assistance") {
      //     messageTxt = assistenciaTemplate(messageTxt)
      //   }

      //   const template = {
      //     ...customMessage,
      //     message: messageTxt,
      //   }

      //   if (!messageTxt || !messageTxt.includes("{{1}}")) {
      //     const proceed = await swal({
      //       title: "Você não digitou, ou esqueceu de digitar {{1}} para configurar seu link.",
      //       text: "Deseja prosseguir?",
      //       icon: "warning",
      //       buttons: {
      //         cancel: "Cancelar",
      //         confirm: {
      //           text: "Sim, desejo",
      //         },
      //       },
      //     })

      //     if (!proceed) {
      //       console.log("Operação cancelada pelo usuário.")
      //       return
      //     }

      //     await sendData(template)
      //   } else {
      //     await sendData(template)
      //   }
      // }
    } catch (e) {
      console.error("Erro inesperado:", e)
    }
  }

  console.log("DFDF", groupQuestions, !values?.question || values.question.length === 0
    ? getCorrectQuestions(groupQuestions, groupQuestionsWithConditional)
    : getCorrectQuestions(values.question, groupQuestionsWithConditional) || [])

  const sendData = async (template) => {
    setLoading(true)
    try {
      const response = await Send.post("/assistance-link/send-one-form", {
        formId: values.form?.value,
        steps:
          selectedStepId && Array(selectedStepId) && selectedStepId.length > 0
            ? selectedStepId?.map((item) => item?.value)
            : [],
        groups:
          selectedGroupId && Array(selectedGroupId) && selectedGroupId.length > 0
            ? selectedGroupId?.map((item) => item?.value)
            : [],
        questions: !values?.question || values.question.length === 0
          ? getCorrectQuestions(groupQuestions, groupQuestionsWithConditional)
          : getCorrectQuestions(values.question, groupQuestionsWithConditional) || [],
        userCreated,
        template,
        farmers: selectedUsers,
      })

      if (response.status === "Error") throw new Error("Erro ao enviar formulário(s).")

      customToast(`${response?.links?.length || 0} formulário(s) enviado(s)`, "success")
      setModalTermsIsOpen(false)
    } catch (error) {
      console.log("Erro ao enviar formulário(s)", error)
      customToast("Erro ao enviar formulário(s)", "error")
    } finally {
      setLoading(false)
    }
  }

  // const handleSendTemplate = async () => {
  //   try {
  //     if(!checkedUsers.length) {
  //       throw new Error('Selecione ao menos um usuário');
  //     }

  //     if(!values || !values.form || !values.step || !values.question) {
  //       throw new Error('Preencha todos os campos!');
  //     }

  //     if(!message && !selectedTemplate?.message) {
  //       throw new Error('Preencha todos os campos!');
  //     }

  //     setLoading(true)

  //     for await (const projectId of projectList) {
  //       const usersToSend = selectedUsers.filter(row => row?.projectId === projectId);

  //       if(projectId && usersToSend.length) {
  //         await Send.post("/message/terms", {
  //           message: message || selectedTemplate?.message || null,
  //           projectId,
  //           farmers: formatUsers(usersToSend, true),
  //           ...values,
  //         })
  //         .then((response) => {
  //           customToast(`Template enviado para os usuários do projeto: "${usersToSend[0]?.project}"`, 'success')
  //         })
  //         .catch((e) => {
  //           customToast(`Erro ao enviar para o projeto: "${usersToSend[0]?.project}"`, 'error');
  //           console.log({ e })
  //         })
  //       }
  //     }

  //     handleCloseModal();
  //     setLoading(false)
  //     console.log("Enviando Template");
  //     customToast('Enviando Template', 'success');
  //   } catch(error) {
  //     console.log("Erro ao enviar termo de uso.", error);
  //     customToast(error.message, 'error');
  //   }
  // }

  const handleMessage = (e) => {
    const textarea = e.target
    const newText = e.target.value
    const header = "Assistência:\n\n"
    const footer = "\n\n👩‍🌾"

    const cleanText = newText.replaceAll(header, "").replaceAll(footer, "")

    setMessage(cleanText)
    setTimeout(() => {
      const cursorPosition = Math.min(header.length + cleanText.length, textarea.selectionStart)
      textarea.setSelectionRange(cursorPosition, cursorPosition)
    }, 0)
  }

  const handleCreateTemplate = () => {
    const message = `Olá, gostaria de cadastrar um template personalizado para o meu uso.`
    window.open(
      encodeURI(`https://wa.me/559892487263?text=${message}`),
      "_blank",
      "noopener,noreferrer",
    )
  }

  return (
    <SendTermsOfUseScreen
      {...{
        modalTermsIsOpen,
        setModalTermsIsOpen,
        handleCloseModal,
        handleSelectedTerm,
        templateTermsList: templateTermsList(scope?.id) ?? [],
        selectedUsers: formatUsers(selectedUsers),
        selectedTerm,
        checkedUsers,
        onCheckedChange,
        handleSendTemplate: sendDataToGenerateLink,
        loading,
        formsByProject,
        handleChangeInput,
        handleCreateTemplate,
        steps,
        groups,
        groupQuestions,
        values,
        handleMessage,
        message,
        showTemplateList,
        handleOpenTemplateList,
        handleCloseTemplateList,
        selectedTemplate,
        handleSetSelectedTemplate,
        selectedTemplate,
        pinnedMessages,
      }}
    />
  )
}

const getCorrectQuestions = (questions, conditionalQuestionsGroup) => {
  // Pegamos os valores selecionados
  const selectedQuestions = questions?.map((item) => item?.value) || []

  // Criamos um Set para armazenar todas as perguntas (evita duplicação)
  const allQuestions = new Set(selectedQuestions)

  // Função recursiva para encontrar perguntas condicionais
  const addConditionalQuestions = (questionValues) => {
    conditionalQuestionsGroup.forEach((question) => {
      if (
        question.isConditional && // Se for condicional
        !allQuestions.has(question.value) && // Se ainda não estiver na lista
        questionValues.includes(question.isConditional)
      ) {
        allQuestions.add(question.value)
        addConditionalQuestions([question.order]) // Chama recursivamente para verificar se há outras condicionais
      }
    })
  }

  // Inicia a busca por perguntas condicionais
  addConditionalQuestions(
    selectedQuestions.map((q) => {
      const selected = conditionalQuestionsGroup.find((item) => item.value === q)
      return selected?.order
    }),
  )

  return Array.from(allQuestions)
}
